module.exports = __webpack_public_path__ + "static/media/droneHealthErrorIcon.56630612.svg";